import { handleUrl, myHeadersWithToken } from '../global';
import { DetailProps } from '../login/types';
import {
  MfaCodeParams,
  MfaLoginProps,
  MfaSetupProps,
  MfaTokenParams,
} from './types';

const authHeaders = (token: string, json = true): Headers => {
  const myHeaders = myHeadersWithToken();
  myHeaders.set('Authorization', `Bearer ${token}`);
  if (json) {
    myHeaders.set('Content-Type', 'application/json');
  }

  return myHeaders;
};

const postJson = <T>(
  path: string,
  token: string,
  body?: object
): Promise<T> => {
  const requestOptions = {
    method: 'POST',
    headers: authHeaders(token, body !== undefined),
    ...(body !== undefined && { body: JSON.stringify(body) }),
  };

  return fetch(`${handleUrl()}${path}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

/** Sends the OTP code over SMS/e-mail. Only for users not required to use TOTP. */
export const otpSend = ({ token }: MfaTokenParams): Promise<DetailProps> =>
  postJson('/api/V1/otp/send', token);

/** Turns OTP on during the first access. Keeps the token in use. */
export const otpEnable = ({
  code,
  token,
}: MfaCodeParams): Promise<DetailProps> =>
  postJson('/api/V1/otp/enable', token, { code });

/** Answers the login payload. An enforced user stays pending (REAL-3264). */
export const otpVerify = ({
  code,
  token,
}: MfaCodeParams): Promise<MfaLoginProps> =>
  postJson('/api/V1/otp/verify', token, { code });

/** Each call mints a new secret and drops the previous one. */
export const totpSetup = ({ token }: MfaTokenParams): Promise<MfaSetupProps> =>
  postJson('/api/V1/totp/setup', token);

/**
 * Enrolling from a pending token upgrades the session and answers the login
 * payload; from a full token (first access) it answers `detail` only.
 */
export const totpEnable = ({
  code,
  token,
}: MfaCodeParams): Promise<MfaLoginProps> =>
  postJson('/api/V1/totp/enable', token, { code });

/** Answers the login payload with a full access_token. */
export const totpVerify = ({
  code,
  token,
}: MfaCodeParams): Promise<MfaLoginProps> =>
  postJson('/api/V1/totp/verify', token, { code });
